export default {
  SystemConfig:{
    BaseUrl:"https://api.aixuejie.cn:8880",
    // BaseUrl:'http://192.168.1.168:8880',
    PreViewUrl:"http://img.aixuejie.cn",
    WebVersion:"20211201-dev-1.0.0",
  }
}




// WEBPACK FOOTER //
// ./src/common/common.js